// @flow
import * as React from 'react';

import PlatformSettingsForm from './ProductSettingsForm';

type Props = { product: string };
const ProductSettings = ({ product }: Props): React.Node => {
    return <PlatformSettingsForm key={product} product={product} />;
};

export default ProductSettings;
